// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dis[data-v-83d07de6] {\n  display: none;\n}\n.qua[data-v-83d07de6] {\n  display: block;\n}\n.title[data-v-83d07de6] {\n  padding-left: 32px;\n  margin-bottom: 18px;\n}\n.title .iconcalss[data-v-83d07de6] {\n  color: red;\n  margin-right: 5px;\n}\n.title span[data-v-83d07de6] {\n  display: inline-block;\n}\n.title .el-radio[data-v-83d07de6] {\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
